import accountApi from '@/api/account'
import jwtDecode from 'jwt-decode'

export const SET_ACCOUNT = 'SET_ACCOUNT'
export const CLEAR_ACCOUNT = 'CLEAR_ACCOUNT'

const state = {
  account: {}
}

const getters = {
  getterAccount: (state) => state.account
}

const mutations = {
  [SET_ACCOUNT] (state, values) {
    window.localStorage.setItem('token-support', values.token)

    const decodedToken = jwtDecode(values.token)
    state.account = {
      ...decodedToken,
      role: values.role,
      name: values.name
    }
  },
  [CLEAR_ACCOUNT] (state) {
    window.localStorage.removeItem('token-support')
    state.account = {}
  }
}

const actions = {
  actionSignIn ({ commit }, params) {
    return accountApi.signIn(params.username, params.password, params.applicationAlias)
      .then((response) => {
        if (response.data.applications.find(application => application.alias === 'support-query')) {
          const params = {
            token: response.data.accessToken,
            role: (response.data.applications.find(application => application.alias === 'support-query' && application.roles.find(role => role.alias === 'administrator')))
              ? 'administrator' : 'suporte',
            name: response.data.user.name
          }

          commit(SET_ACCOUNT, params)
          return Promise.resolve(response.data)
        } else {
          throw new Error('Unauthorized')
        }
      })
      .catch((e) => {
        if (e.message === 'Unauthorized') {
          return Promise.reject(e.message)
        }

        return Promise.reject(e.response.data.error.message)
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
